import {Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {ConfirmDialogComponent, ConfirmDialogData} from "../confirm-dialog/confirm-dialog.component";
import {FormBuilder, FormControl} from "@angular/forms";
import {takeUntil} from "rxjs/operators";
import {ReplaySubject} from "rxjs";

@Component({
  selector: 'app-users-dialog',
  templateUrl: './users-dialog.component.html',
  styleUrls: ['./users-dialog.component.scss']
})
export class UsersDialogComponent implements OnInit, OnDestroy {
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  text = '';
  body = '';
  userControl: FormControl;
  active = false;

  constructor(
    public dialogRef: MatDialogRef<ConfirmDialogComponent>,
    private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmDialogData
  ) {
    this.text = data.text;
    this.body = data.text;
    this.userControl = fb.control('');
  }

  ngOnInit(): void {
    this.userControl.valueChanges
      .pipe(takeUntil(this.destroyed$))
      .subscribe((value) => {
          if (value) {
            this.active = true;
          } else {
            this.active = false;
          }
        }
      );
  }

  confirm(): void {
    this.dialogRef.close(this.userControl.value);
  }

  decline(): void {
    this.dialogRef.close(false);
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

}
